import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import dayjs from '@/js/libs/dayjs';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Media } from '@/js/libs/ui/src/theme/Media';
import { Select } from '@/js/libs/ui/src/V2';
import { PresetItem } from './PresetItem';
import { Header, MobileHeader, PresetsWrapper } from './styled';
export const TimePresets = memo(function TimePresets({ presets, date, onChange, isDateSelected, dataTestId, translations, }) {
    const title = translations.time;
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const selectOptions = useMemo(() => presets.map(({ title, value }) => ({
        label: title,
        value,
    })), [presets]);
    const selectedValue = useMemo(() => {
        const activePreset = presets.find(({ isActive, value }) => isActive(value, date));
        return activePreset ? { label: activePreset.title, value: activePreset.value } : undefined;
    }, [date, presets]);
    const applyTimePreset = useCallbackRef((presetValue) => {
        if (!date)
            return;
        const timePresetDate = dayjs(presetValue);
        const currentDate = dayjs(date);
        if (timePresetDate.isValid() && currentDate.isValid()) {
            const updatedValue = currentDate.hour(timePresetDate.hour()).minute(timePresetDate.minute());
            onChange(updatedValue.toDate());
        }
    });
    const handleSelectChange = useCallbackRef((option) => {
        if (!option)
            return;
        applyTimePreset(option.value);
    });
    const createTimePresetClickHandler = useCallbackRef((value) => () => {
        if (!isDateSelected)
            return;
        applyTimePreset(value);
    });
    if (!isDateSelected) {
        return null;
    }
    return (_jsx("div", { children: isMobile ? (_jsxs("div", { children: [_jsx(MobileHeader, { children: title }), _jsx(Select, { options: selectOptions, value: selectedValue, onChange: handleSelectChange, isDisabled: !isDateSelected })] })) : (_jsxs(_Fragment, { children: [_jsx(Header, { children: title }), _jsx(PresetsWrapper, { "data-testid": dataTestId ? `${dataTestId}-time-presets` : undefined, children: presets.map(({ isActive, title, value }) => {
                        const isActivePreset = isActive(value, date);
                        const presetTestId = dataTestId ? `${dataTestId}-time-preset-${title.replace(':', '')}` : undefined;
                        return (_jsx(PresetItem, { title: title, isActive: isActivePreset, onClick: createTimePresetClickHandler(value), dataTestId: presetTestId }, title));
                    }) })] })) }));
});
